import { isPlatformServer } from '@angular/common';
import { EnvironmentProviders, Injector, PLATFORM_ID, REQUEST_CONTEXT, inject, provideAppInitializer } from '@angular/core';

import { NativeEventType } from '../native-app/native-app.models';
import { NativeAppService } from '../native-app/native-app.service';
import { ProductService } from '../products/product.service';
import { BootstrapperService } from './bootstrapper.service';

export function appInitializerFactory(
    bootstrapperService: BootstrapperService,
    nativeAppService: NativeAppService,
    productService: ProductService,
    injector: Injector,
) {
    return async () => {
        productService.register('host', injector);

        await bootstrapperService.runAppInit();

        nativeAppService.sendToNative({ eventName: NativeEventType.APPINITIALIZED });
    };
}

export function provideBootstrap(): EnvironmentProviders[] {
    // TODO remove this when running in Route Exploration!
    return [
        provideAppInitializer(() => {
            if (isPlatformServer(inject(PLATFORM_ID)) && inject(REQUEST_CONTEXT) === null) {
                return;
            }
            const initializerFn = appInitializerFactory(
                inject(BootstrapperService),
                inject(NativeAppService),
                inject(ProductService),
                inject(Injector),
            );
            return initializerFn();
        }),
    ];
}
